import { format, parseISO, isValid } from "date-fns";
import { toZonedTime } from "date-fns-tz";

import { DEFAULT_BENEFIT } from "src/constants/stats";
import { InsuranceKeyProps, CaseDetailProps as InsuranceProps } from "../components/manufacturer/stepperModal/types";
// import { format, isValid, parseISO } from "date-fns";
// import { toZonedTime } from "date-fns-tz";


export const calculateDrugValueBasedOnParams = (drugFromParam: string | null): string => {
  if (!drugFromParam) return "";

  if (drugFromParam.toLowerCase().includes("product")) return ""
  else if (drugFromParam.toLowerCase() === "iovera") return "iovera°"
  else return drugFromParam
}

export const doesBenefitHasInOrOutNetwork = (insurance_data: InsuranceProps): string => {
  const { in_network_tab, out_network_tab } = insurance_data;
  const isInNetworkUpdated = Object.keys(in_network_tab).map((key: unknown) => {
    return DEFAULT_BENEFIT[key as InsuranceKeyProps] !== in_network_tab[key as InsuranceKeyProps].trim()
  })

  const isOutNetworkUpdated = Object.keys(out_network_tab).map((key: unknown) => {
    return DEFAULT_BENEFIT[key as InsuranceKeyProps] !== out_network_tab[key as InsuranceKeyProps].trim()
  })

  if (isInNetworkUpdated) return "in_network"
  else if (isOutNetworkUpdated) return "out_network"
  else return ""
}
export function isExactFormatWith3Millis(value: string): boolean {
  return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(value);
}

// export const formatDateMDY = (value: string | null): string => {
//   if (!value) return "";

//   let date: Date | null = null;
//   if (isExactFormatWith3Millis(value)) {
//     date = parseISO(value);
//   } else if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
//     date = parseISO(`${value}T00:00:00Z`);
//   } else {
//     date = parseISO(value);
//   }

//   if (!date || !isValid(date)) return "";

//   // Force UTC → prevent timezone shifts
//   const utcDate = toZonedTime(date, "UTC");
//   return format(utcDate, "M/d/yyyy");
// };


export const formatDateMDY = (value: string | null): string => {
  if (!value) return "";

  let date: Date | null = null;

  if (isExactFormatWith3Millis(value)) {
    date = parseISO(value);
  } else if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    // date only
    date = parseISO(`${value}T00:00:00Z`);
  } else {
    date = parseISO(value);
  }

  if (!date || !isValid(date)) return "";

  // Force UTC → prevent timezone shifts
  const utcDate = toZonedTime(date, "UTC");

  const hasTime =
    value.includes("T") ||       // ISO datetime
    /\d{2}:\d{2}/.test(value);  // 15:33 format

  // If time exists → show date + time
  if (hasTime) {
    return format(utcDate, "M/d/yyyy h:mm a");
  }

  // Else → date only
  return format(utcDate, "M/d/yyyy");
};